// extracted by mini-css-extract-plugin
module.exports = {"linkToDetail":"LinkToDetail_linkToDetail__3cL8t"};